export { DMS_MODULE } from '../constants';
export const NAME = 'NationalCPF';
export const CRUMB_LABEL_KEY = 'NationalCPF';
